export const mbCheckout = {

  checkoutCommon: {
    saveAndContinue: 'Save and continue',
    AddNewAddress: 'Add new address'
  },

  navigationPage: {
    nextBtn: 'Continue',
    backBtn: 'Back',
    cancelBtn: 'Cancel',
    saveAndContinueBtn: 'Save and Continue',
  },

  checkoutProgressBar: {
    contactDetails: 'Contact details',
    shippingAddress: 'Shipping address',
    billingInformation: 'Billing information',
    review: 'Review',
  },

  orderConfirmation: {
    thankYou: 'Thank you!',
    requestNumber: 'Request number: ',
    orderRequestSubtitle1: 'A copy has been sent to {{email}}.',
    orderRequestSubtitle2: 'We will get in touch as soon as possible.',
    orderNumber: 'Order number: ',
    orderSubtitle: 'You will receive an emailed confirmation shortly.',
  },
  checkoutErrors: {
    payment: {
      cancelled: 'The transaction was cancelled.',
      needs_3ds: 'The transaction needs 3DS.',
      in_progress: 'The transaction is in progress.',
      rejected: 'The transaction was rejected.',
      failed: 'The transaction failed.',
    }
  }
}
